module.exports = __webpack_public_path__ + "static/media/IC_cap_modeling.d4e5f8d6.svg";